<template>
  <div class="small-form-grid" id="tilslagsmodul">
    <div class="grid-x grid-padding-x">
      <div class="cell auto">
        <label for="Katalognr">Katalognr</label>
        <div class="input-container disabled">
          <input id="Katalognr" type="number" :value="objekt.Katalognr" disabled>
        </div>
      </div>
      <div class="cell shrink">
        <label for="Vurderingspris2">Lav vurd.</label>
        <div class="input-container disabled">
          <input id="Vurderingspris2" type="text" :value="this.$options.filters.thousands(objekt.Vurderingspris2)" disabled>
        </div>
      </div>

      <TheIntegerInput
        v-model.trim="form.Salgspris"
        label="Tilslag"
        name="Tilslag"
        symbol="kr"
        containerClassName="cell large-7"
        maxlength="10"
        v-validate="rulesSalgspris"
        :hideErrorMsg="true"
        :tabindex="1"
      />

      <TheIntegerInput
        v-model.trim="form.Tilslagnr"
        label="Tilslagsnr / Spade"
        name="Tilslagnr"
        containerClassName="cell large-5"
        maxlength="5"
        v-validate="rulesTilslagnr"
        :hideErrorMsg="true"
        @blur="lookupCustomer"
        :tabindex="2"
        ref="tilslagnr"
      />

      <TheAutoCompleteInput
        v-model.trim="mottakerName"
        containerClassName="cell small-12"
        name="MottakerName"
        :placeholder="'Velg kjøper...'"
        :label="form.Mottaker ? 'Kjøper: #' + form.Mottaker : 'Kjøper: -'"
        v-validate="'min:1'"
        :onInputCallback="onKundeSearchInput"
        :onSelectCallback="onKundeSearchSelected"
        :onResetCallback="onKundeSearchReset"
        :debounce="1250"
        :minquery="2"
      >
        <div slot="item" slot-scope="props">
          <strong>{{props.item.Kundenr}}</strong> {{props.item.full_name}}
        </div>
      </TheAutoCompleteInput>

      <div class="cell">
        <div class="input-container" style="margin-bottom:1rem">
          <label for="objektNotat">
            Objektnotat
            <span v-if="objektNotatLoading">(Laster...)</span>
            <span v-else-if="objektNotatCount === 1"><a href="javascript:;" @click="showNotes">(1 notat)</a></span>
            <span v-else><a href="javascript:;" @click="showNotes">({{objektNotatCount}} notater)</a></span>
          </label>
          <textarea
            rows="2"
            tabindex="3"
            autocomplete="off"
            placeholder="Legg til merknad…"
            v-model="objektNotat"
            v-validate="'max:500'"
            name="objektNotat"
            id="objektNotat"
            :class="{ 'error': errors.has('objektNotat') }"></textarea>
        </div>
      </div>

      <div class="cell large-12">
        <div class="radio-button-container pill" :class="{ 'form-error': errors.has('Legitimert') }">
          <ul>
            <li><input type="radio" v-model="form.Mfgs" v-bind:value="'M'" name="Mfgs" id="mfgs-m"> <label for="mfgs-m">Med forbehold</label></li>
            <li><input type="radio" v-model="form.Mfgs" v-bind:value="'G'" name="Mfgs" id="mfgs-g"> <label for="mfgs-g">Godkjent salg</label></li>
          </ul>
        </div>
      </div>

      <div class="cell large-12" v-if="errors.all().length > 0 || salgsprisMessage">
        <div class="panel small error">
          <ul>
            <li v-if="salgsprisMessage">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{salgsprisMessage}}
            </li>
            <li v-if="errors.has('Tilslag')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('Tilslag')}}
            </li>
            <li v-if="errors.has('Tilslagnr')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('Tilslagnr')}}
            </li>
            <li v-if="errors.has('objektNotat')">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg></span>
              {{errors.first('objektNotat')}}
            </li>
          </ul>
        </div>
      </div>

      <div class="cell auto">
        <a href="javascript:;" @click="onPrevClick" title="Forrige" class="button small secondary arrow-prev"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg></a>
        <a href="javascript:;" @click="onNextClick" class="button small secondary arrow-next"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg></a>
      </div>
      <div class="cell shrink" v-if="loading || !changed">
        <button type="submit" class="button small primary disabled">Lagre</button>
      </div>
      <div class="cell shrink" v-else-if="changed">
        <button v-if="!saving" tabindex="3" @click="handleSubmit" type="submit" class="button small primary">Lagre</button>
        <button v-else type="submit" class="button small primary loading">Lagre <span class="loader-spinner"></span></button>
      </div>
    </div>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'
import TheAutoCompleteInput from '../../../Inputs/TheAutoCompleteInput'
import ObjektService from '../../../../services/ObjektService'
import AuksjonService from '../../../../services/AuksjonService'

export default {
  name: 'TheSidebarObjectModule',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  props: {
    objekt: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      saving: false,
      checked: {},
      template: [
        'Salgspris',
        'Tilslagnr',
        'Mfgs',
        'Mottaker'
      ],
      used: [],
      form: {},
      orig: {},
      objektNotat: null,
      mottakerName: null,
      salgsprisMessage: null
    }
  },
  computed: {
    changed: function () {
      return !this._.isEqual(this.form, this.orig) || this.objektNotat
    },
    rulesSalgspris: function () {
      return {
        integer: true,
        required: false
        // min_value: this.objekt.Minstepris || 0
      }
    },
    rulesTilslagnr: function () {
      return {
        integer: true,
        required: false
        // min_value: 1
        // max_value: 3990,
        // checkTilslagnr: true
      }
    },
    objektNotatLoading: function () {
      return this.$store.getters['objektnotat/loading']
    },
    objektNotatCount: function () {
      return this.$store.getters['objektnotat/totalCount']
    }
  },
  watch: {
    objekt: function (newVal) {
      this.initObject()
    },
    'form.Salgspris': function () {
      if (this.form.Salgspris && this.form.Salgspris < this.objekt.Minstepris) {
        this.salgsprisMessage = 'Tilslag er lavere enn minstepris (' + this.$options.filters.thousands(this.objekt.Minstepris) + ')'
      } else {
        this.salgsprisMessage = null
      }
    }
  },
  mounted () {
    this.initObject()
  },
  methods: {
    lookupCustomer: function () {
      const ts = this.form.Tilslagnr ? parseInt(this.form.Tilslagnr) : null

      if (!ts || ts === 950) {
        // Just reset buyer...
        this.onKundeSearchReset()
      } else if (this.checked.hasOwnProperty(ts)) {
        // Already checked this
        if (!this.checked[ts]) {
          this.onKundeSearchReset()
        } else {
          this.onKundeSearchSelected(this.checked[ts])
        }
      } else {
        // Do check with backend...
        AuksjonService.lookupCustomer(this.objekt.Auksjon, ts)
          .then(response => {
            this.checked[ts] = response.data
            this.onKundeSearchSelected(response.data)
          })
          .catch(error => {
            console.log('Not found', error)

            this.checked[ts] = false
            this.onKundeSearchReset()
          })
      }
    },
    showNotes: function () {
      // TilslagsskjermbildeSidebarNotesModal
      this.openModal(
        'tilslagsskjermbilde-sidebar-notes-modal',
        { objekt: this.objekt },
        'right'
      )
    },
    onKundeSearchReset: function () {
      this.form.Mottaker = ''
      this.mottakerName = ''
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeSearchSelected: function (item) {
      this.form.Mottaker = item.Kundenr || ''
      this.mottakerName = item.parsed_name || ''
    },
    initObject: function () {
      this.checked = {}

      // Clear error bag
      this.errors.clear()

      // Load objektnotater
      this.$store.dispatch('objektnotat/reinit', {
        Kundenr: this.objekt.Innlevav,
        Kontraktnr: this.objekt.Kontraktnr,
        Objektid: this.objekt.Objektid
      })

      // Make orig based on template
      this.orig = Object.assign({}, ...this.template.map(i => ({[i]: ''})), this._.pick(this.objekt, this.template))

      // And convert to String values
      Object.keys(this.orig).forEach(k => {
        if (this.orig[k] === null) {
          this.orig[k] = ''
        } else {
          this.orig[k] = String(this.orig[k])
        }
      })

      // And now copy to form
      this.form = this._.cloneDeep(this.orig)

      if (this.objekt.mottaker && this.objekt.mottaker.Kundenr) {
        this.mottakerName = this.objekt.mottaker.parsed_name
      } else {
        this.mottakerName = ''

        // Try to find customer
        if (this.orig.Tilslagnr) {
          this.lookupCustomer()
        }
      }

      this.objektNotat = null

      // Set focus to Tilslag input
      window.jQuery('input[name="Tilslag"]', window.jQuery('#tilslagsmodul')).focus()
    },
    handleSubmit: function () {
      if (this.saving || !this.changed) {
        console.log('Nothing to do...')
        return
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            console.log('Failed validation')
          } else {
            this.save()
          }
        })
    },
    save: function () {
      this.saving = true

      const save = {}

      // Set all non empty strings
      Object.keys(this.form).forEach(k => {
        let v = this.form[k] === '' ? null : this.form[k]

        if (this.form[k] !== this.orig[k]) {
          save[k] = v
        }
      })

      save.Mottaker = this.form.Mottaker

      // Set possible obejkt notat
      if (this.objektNotat) {
        save.Notat = this.objektNotat
      }

      // Lastly save...
      ObjektService.updateTilslag(this.objekt.Objektid, save)
        .then(response => {
          // Return merged object
          this.$emit('on-save', Object.assign({}, this.objekt, response.data))
        })
        .catch(error => {
          console.log('Error', error)
          this.$helpers.showErrorAlert('Feil', 'Noe gikk feil i lagringen.')
        })
        .then(() => {
          this.saving = false
        })
    },
    onPrevClick: function () {
      if (this.changed) {
        this.$helpers.showWarningAlert('Lagre', 'Du må lagre endringer før du kan gå videre...')
      } else {
        this.$emit('prev')
      }
    },
    onNextClick: function () {
      if (this.changed) {
        this.$helpers.showWarningAlert('Lagre', 'Du må lagre endringer før du kan gå videre...')
      } else {
        this.$emit('next')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Tilslagsskjermbilde/TheSidebarObjectModule.vue